import React, { useContext, useState, useEffect } from 'react';

import BusinessIcon from '@mui/icons-material/Business';
import { Container, Grid } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import { LoadingContext } from 'common/utils/contexts';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const CompaniesContainer = ({
    companies,
    countries,
    downloadFile,
    fetchCompanies,
    fetchCountries,
    isFetching,
    isFetchingCountries,
    isFetchingCSV,
    pagination,
}) => {
    const { t } = useTranslation();
    const loadingContext = useContext(LoadingContext);
    const [filterData, setFilterData] = useState({
        countryName: '',
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        planName: '',
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });

    useEffect(() => {
        fetchCompanies(filterData);
        fetchCountries();
    }, []);

    useEffect(() => {
        if (isEmpty(loadingContext)) return;
        if (isFetchingCSV)
            loadingContext.openLoading(t('Downloading CSV').concat('...'));
        else loadingContext.closeLoading();
    }, [isFetchingCSV]);

    return (
        <Container maxWidth={false}>
            <HeaderContainer>
                <Grid>
                    <TitleIcon
                        icon={<BusinessIcon />}
                        title={t('Company', { count: 2 })}
                    />
                </Grid>
            </HeaderContainer>

            <ListItems
                downloadFile={downloadFile}
                filterData={filterData}
                filterItems={fetchCompanies}
                isFetching={isFetching}
                items={companies}
                paginationData={pagination}
                setFilterData={setFilterData}
                countries={countries}
                isFetchingCountries={isFetchingCountries}
            />
        </Container>
    );
};

CompaniesContainer.propTypes = {
    companies: PropTypes.array,
    countries: PropTypes.array,
    downloadFile: PropTypes.func,
    fetchCompanies: PropTypes.func,
    fetchCountries: PropTypes.func,
    isFetching: PropTypes.bool,
    isFetchingCountries: PropTypes.bool,
    isFetchingCSV: PropTypes.bool,
    pagination: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
    companies: selectors.getCompaniesData,
    countries: selectors.getContriesData,
    isFetching: selectors.getCompaniesIsFetching,
    isFetchingCountries: selectors.getIsFetchingCountries,
    isFetchingCSV: selectors.getIsFetchingCompaniesCSV,
    pagination: selectors.getCompaniesPagination,
});

const mapDispatchToProps = (dispatch) => ({
    downloadFile: (filterData) => dispatch(actions.downloadFile(filterData)),
    fetchCompanies: (filterData) =>
        dispatch(actions.fetchCompanies(filterData)),
    fetchCountries: () => dispatch(actions.fetchCountries()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(CompaniesContainer));
